module.exports = __webpack_public_path__ + "img/glyphicons-halflings-regular.woff?fa2772327f55d8198301fdb8bcfc8158";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/bootstrapv3/fonts/glyphicons-halflings-regular.woff
// module id = 588
// module chunks = 0